import { useMemo } from "react";
import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import VideoCard from "@/components/feature/VideoCard";
import SpecialCard from "@/components/feature/SpecialCard";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import { specials, videos, formatViews } from "@/mocks/videos";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Home() {
  usePageMeta(
    "亲嘴视频-精选亲吻视频合集在线播放",
    "亲嘴视频网站为您提供丰富多样的亲吻视频资源，涵盖影视片段、短视频和情感专辑，满足用户在线观看和浏览亲吻视频的需求。"
  );

  const featured = useMemo(
    () => videos.filter((v) => v.heroCover),
    []
  );

  const latest = useMemo(
    () =>
      [...videos]
        .sort((a, b) => b.uploadedAt.localeCompare(a.uploadedAt))
        .slice(0, 8),
    []
  );

  const hot = useMemo(
    () => [...videos].sort((a, b) => b.views - a.views).slice(0, 4),
    []
  );

  return (
    <SiteLayout hasTopPadding={false}>
      <HeroCarousel items={featured} />

      <CategoryEntries />

      <section className="w-full px-4 md:px-8 py-12 md:py-14 bg-background-100">
        <div className="flex items-end justify-between mb-6 md:mb-8 gap-4 flex-wrap">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              最新上传
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              刚刚上线的亲吻视频作品，第一时间发现新内容
            </p>
          </div>
          <Link
            to="/search"
            className="text-sm text-primary-600 font-medium hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部 &gt;
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {latest.map((video, index) => (
            <VideoCard key={video.id} video={video} index={index} />
          ))}
        </div>
      </section>

      <section className="w-full px-4 md:px-8 py-12 md:py-14">
        <div className="flex items-end justify-between mb-6 md:mb-8 gap-4 flex-wrap">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              热门视频推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              播放量与收藏数最高的作品，大家都在看
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
            {hot.slice(0, 4).map((video, index) => (
              <VideoCard key={video.id} video={video} index={index} />
            ))}
          </div>
          <div className="lg:col-span-4 rounded-lg border border-background-200/70 bg-background-100 p-5 md:p-6">
            <h3 className="font-heading text-xl text-foreground-950 mb-4 flex items-center gap-2">
              <i className="ri-fire-line text-accent-500" />
              热度排行
            </h3>
            <ol className="space-y-4">
              {[...videos]
                .sort((a, b) => b.views - a.views)
                .slice(0, 6)
                .map((video, index) => (
                  <li key={video.id}>
                    <Link
                      to={`/detail/${video.id}`}
                      className="group flex items-start gap-3 cursor-pointer"
                    >
                      <span
                        className={`w-6 h-6 shrink-0 flex items-center justify-center rounded text-xs font-label ${
                          index < 3
                            ? "bg-primary-500 text-background-50"
                            : "bg-background-200 text-foreground-600"
                        }`}
                      >
                        {index + 1}
                      </span>
                      <div className="min-w-0">
                        <p className="text-sm text-foreground-950 font-medium line-clamp-1 group-hover:text-primary-600 transition-colors">
                          {video.title}
                        </p>
                        <p className="text-xs text-foreground-500 mt-0.5">
                          {formatViews(video.views)} 次播放
                        </p>
                      </div>
                    </Link>
                  </li>
                ))}
            </ol>
          </div>
        </div>
      </section>

      <section
        id="specials"
        className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100 scroll-mt-20"
      >
        <div className="flex items-end justify-between mb-6 md:mb-8 gap-4 flex-wrap">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              专题推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              围绕主题策划的亲吻视频合集，一次看个够
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {specials.map((special, index) => (
            <SpecialCard key={special.id} special={special} index={index} />
          ))}
        </div>
      </section>

      <section className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-label mb-5">
            <i className="ri-heart-3-fill" />
            关于亲嘴视频
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-5 leading-snug">
            专注亲吻主题的视频内容平台
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-3xl mx-auto">
            亲嘴视频专注于收集与整理各类亲吻主题视频资源，涵盖影视片段精选、短视频合集与情感专题。我们希望通过清晰的分类、便捷的筛选与舒适的播放体验，帮助每一位观众快速找到打动自己的那一幕。
          </p>
          <div className="mt-8 flex items-center justify-center gap-3 flex-wrap">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              了解更多
            </Link>
            <Link
              to="/search"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-secondary-100 text-secondary-900 text-sm font-medium hover:bg-secondary-200 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-search-line" />
              搜索视频
            </Link>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}